import * as yup from 'yup'

export const validateLogin = yup.object().shape({
    email: yup.string().required('Required field.').email('Introduzca un correo electrónico válido.'),
    password: yup.string().required('Required field.').min(6, 'Debe introducir una contraseña de al menos 6 caracteres.'),
})